module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAABYlAAAWJQFJUiTwAAABXElEQVRYhe2Y7Y3CMAxAfScGYBRGODaBEdwNWCAWE8AIbAAj3AiMcCOgoESqWlPs1vHdSX4/3TZ+/UrsfIAxHeIaADb9URPRzTLLylq6CF8HMdOH82k5mBch7UVIexHSXoS0FyHtRUh78S+lZ5empW7OJegxEZ2V155KCbtNRD/a3LOedE84Jz51iDvFtVl4V+vuMpYKtfRAuCIS7wlXuIbhLWrp8jq/mUOT4oxwhRtrklEbJO3xJiTOTJyLPeOJaK/Nz/2Ioh4vJ+sQgZHh5ETC0vyLprySVDVzFF4Ji1g8T88QXyQMVouLQnyxMFiuiAJxE2GwXsYnxM2EoUXtwYibCkOrgqknbi4MjfbynrSQrUQ97UVIexHSXoimvA7xy9Fp8+4ETpprNNUtUUtGn0ciyu3P/Q85XoaBV980tncRkd/6YXgiK52I8t1t5zSdhlzKvshvOgRBewDgASGEeS9RDne3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/70.png
// module id = RGWU
// module chunks = 1